import {Store, Map} from "../models/";

class Position {

  // =========================
  // 🔹 GEOLOCATION ENTRY POINT
  // =========================

  async getPos(geolocationEnabled: Function, geolocationDisabled: Function) {
    if (!navigator.geolocation) {
      return geolocationDisabled();
    }

    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        geolocationEnabled(pos);
      }
    );

    return geolocationDisabled();
  }

  // =========================
  // 🔹 GEOLOCATION SUCCESS FLOW
  // =========================

  geolocationEnabled(pos: google.maps.LatLng, stores: Store[], map: google.maps.Map | undefined, deps: {
      updateDistance: (stores: Store[], pos: google.maps.LatLng) => Store[];
      getClosest: (n: number, stores: Store[]) => Store[];
      createBounds: (store: Store, pos: google.maps.LatLng) => google.maps.LatLngBounds;
      createPositionMarker: (pos: google.maps.LatLng, map?: google.maps.Map) => any;
    }
  ) {
    const updatedStores = deps.updateDistance(stores, pos);
    const closestStores = deps.getClosest(3, updatedStores);

    const bounds = deps.createBounds(closestStores[0], pos);
    const positionMarker = deps.createPositionMarker(pos, map);

    return new Map({
      updatedStores,
      closestStores,
      positionMarker,
      bounds,
      pos,
      map
    });
  }

  // =========================
  // 🔹 GEOLOCATION FALLBACK FLOW
  // =========================

  geolocationDisabled(stores: Store[], countryCode: string) {
    const bounds = new google.maps.LatLngBounds();

    const countryCodeStores = stores.filter(store =>
      store.countryCode.toLowerCase() === countryCode
    );

    countryCodeStores.forEach(store => {
      if (store.lat && store.lng) {
        bounds.extend(new google.maps.LatLng(store.lat, store.lng));
      }
    });

    return bounds;
  }

  // =========================
  // 🔹 MAP ZOOM ADJUSTMENT
  // =========================

  extendZoom(map: Map) {
    let zoomLevel = 15;

    const zoomInterval = setInterval(() => {
      const first = map.closestStores[0];

      if (!first?.marker?.position) {
        clearInterval(zoomInterval);
        return;
      }

      map.map?.setZoom(zoomLevel);

      if (map.map?.getBounds()?.contains(first.marker.position)) {
        clearInterval(zoomInterval);
      } else {
        zoomLevel--;
      }
    }, 200);
  }
}

export const position = new Position();